import React from "react";
import Logo from "../../../assets/images/mahi-download-logo-512.png";
import { getDownloadLink } from "../../../utils/app-download-link";
import { track } from "@amplitude/analytics-browser";

interface DownloadBannerProps {
  closeBanner: () => void;
  bannerHeight: number;
}

const AppDownloadBanner: React.FC<DownloadBannerProps> = ({
  closeBanner,
  bannerHeight,
}) => {
  return (
    <div
      className="fixed top-0 w-full max-w-[742px] bg-[#1692fc] text-white flex items-center justify-between py-2 z-50 px-4 "
      style={{ height: `${bannerHeight}px` }}
    >
      <div className="flex items-center">
        <img src={Logo} className="w-12 h-12" alt="마히 다운로드 로고" />
        <p className="ml-2 text-lg font-semibold text-start text-gray-100 leading-tight">
          <span className="font-extrabold text-white">200,000+</span>명이 <br />
          알림을 받아보고 있어요!
        </p>
      </div>
      <a
        href={getDownloadLink()}
        className="ml-4 px-4 py-2 text-md bg-white text-[#1692fc] font-bold rounded-full shadow hover:bg-[#f1f1f1] transition-all duration-200"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          track("앱 다운로드 클릭", { 어디서: "홈 상단 배너" });
        }}
      >
        앱 다운로드
      </a>
    </div>
  );
};

export default AppDownloadBanner;
